import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { homeAssetSrc } from 'components/landing/v3/homeAssetSrc';
import type { PressOutlet } from './pressItems';
import styles from './RingProUsPress.module.css';

/**
 * Publisher wordmarks, as served from each outlet's own site (Oct 26 2026;
 * Wareable and Yahoo Tech Oct 27 2026).
 * Shown monochrome (see .logo): the CSS filter flattens every mark, including
 * Trusted Reviews' white-on-transparent PNG, to one grey, and to white on hover.
 */
const logo = (file: string) => homeAssetSrc(`web_v2/ring-pro-us/press/${file}`);

const LOGOS: Record<
  PressOutlet,
  { src: string; name: string; width: number; height: number }
> = {
  techAdvisor: {
    src: logo('tech-advisor.svg'),
    name: 'Tech Advisor',
    width: 1626,
    height: 178,
  },
  trustedReviews: {
    src: logo('trusted-reviews.png'),
    name: 'Trusted Reviews',
    width: 1083,
    height: 309,
  },
  engadget: {
    src: logo('engadget.svg'),
    name: 'Engadget',
    width: 600,
    height: 124,
  },
  wareable: {
    src: logo('wareable.svg'),
    name: 'Wareable',
    width: 670,
    height: 101,
  },
  yahooTech: {
    src: logo('yahoo-tech.svg'),
    name: 'Yahoo Tech',
    width: 115,
    height: 20,
  },
};

export const OutletMark = ({ outlet }: { outlet: PressOutlet }) => {
  const mark = LOGOS[outlet];
  return (
    <span className={styles.mark}>
      <CustomImage
        className={`${styles.logo} ${styles[`logo_${outlet}`]}`}
        src={mark.src}
        alt={mark.name}
        width={mark.width}
        height={mark.height}
      />
    </span>
  );
};
